module.exports = __webpack_public_path__ + "img/industrial.30110d4c.png";